import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ChakraProvider } from '@chakra-ui/react'
import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { history, store } from './redux/store'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

import ScrollToTop from '_components/ScrollToTop'
import Root from '_layout/App/Root'
import { AppSignalBoundary, addClarity, addGoogleTagManager } from './helpers/analytics'
import theme from 'theme/theme'

import 'flag-icon-css/css/flag-icon.min.css'
import 'css/style.scss'

addClarity()
addGoogleTagManager()

ReactDOM.render(
  <AppSignalBoundary>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <ChakraProvider theme={theme} resetCss={false}>
          <ScrollToTop>
            <Switch>
              <Route path="/" component={Root} />
            </Switch>
          </ScrollToTop>
        </ChakraProvider>
      </ConnectedRouter>
    </Provider>
  </AppSignalBoundary>,
  document.getElementById('wrapper')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
serviceWorkerRegistration.register()
